import { useQuery } from '@tanstack/react-query';

import { getConfigurationService } from 'service/api/configuration';

import type { Policies } from 'service/api/configuration';
import type { UseQueryOptions } from '@tanstack/react-query';

type UseGetPoliciesOptions = Omit<
  UseQueryOptions<Policies, unknown, Policies, ['getPolicies']>,
  'queryKey' | 'queryFn'
>;

export const useGetPolicies = (options?: UseGetPoliciesOptions) =>
  useQuery<Policies, unknown, Policies, ['getPolicies']>({
    queryKey: ['getPolicies'],
    queryFn: () => getConfigurationService().getPolicies(),
    ...options,
  });
